import { Box } from '@mui/material';
import { ProductTypes } from 'api/types/ReferenceData';
import {
  WHITELABEL_EVENT_KEY,
  WHITELABEL_IMAGE_PLACEHOLDER
} from 'components/constants/Constants';
import { Breadcrumbs } from 'components/pages/products/Breadcrumbs';
import { tss } from 'tss-react/mui';
import { EventProduct, ProductType } from 'types/Products';
import ConceptPageUXB from './ProductPagesByType/ConceptPageUXB';
import IngredientPageUXB from './ProductPagesByType/IngredientPageUXB';
import { TopSection } from './Sections/TopSection';
import { TopContentProps } from './Sections/Types';
import { useSticky } from 'hooks/useOnSticky';
import useNavbarHeight from 'hooks/useNavBarHeight';
import { envs } from '../../../../../../envs';

interface UXBProductPageProps {
  product: EventProduct;
}
export const UXBProductPage = ({ product }: UXBProductPageProps) => {
  const { classes } = useStyles();
  const productTypeLabel =
    ProductTypes.find(el => el.value === product.type)?.label ?? '';

  const breadcrumbs = {
    links: [
      {
        link: `/${productTypeLabel.toLowerCase()}/search`,
        title: productTypeLabel ? `Our ${productTypeLabel}` : ''
      }
    ],
    active: product.name
  };

  const topSectionContent: TopContentProps = {
    title: product.name,
    tag: product?.event?.product_private_attributes?.data?.tagline,
    description: product?.marketing?.description,
    assets: product.assets,
    product: product
  };

  const productPageByType = () => {
    switch (product.type) {
      case ProductType.INGREDIENTS:
        return <IngredientPageUXB product={product} />;
      case ProductType.FORMULATIONS:
        return <ConceptPageUXB product={product} />;

      default:
        return null;
    }
  };
  const navHeight = useNavbarHeight();
  const { ref, isSticky } = useSticky(navHeight);
  return (
    <Box className={classes.pageContainer}>
      <Box
        sx={theme => ({
          position: 'sticky',
          top: 0,
          zIndex: 999,
          backgroundColor: isSticky ? 'white' : 'transparent',
          padding: isSticky ? '16px 0 8px 48px' : '8px 0 ',
          transition: 'all .3s ease',
          boxShadow: isSticky ? theme.shadows[2] : 'none'
        })}
        ref={ref}
      >
        <Breadcrumbs breadcrumbs={breadcrumbs} title={''} />
      </Box>
      <Box className={classes.contentWrapper}>
        <TopSection
          imgs={
            product.event.images?.map((img: any) => ({
              src: `${envs.REACT_APP_COVALO_STATIC_CONTENT}/events/${WHITELABEL_EVENT_KEY}/${img.reference}`,
              alt: product.name
            })) ?? [
              {
                src: WHITELABEL_IMAGE_PLACEHOLDER,
                alt: product.name
              }
            ]
          }
          content={topSectionContent}
        />
        {productPageByType()}
      </Box>
    </Box>
  );
};

const useStyles = tss.create(({ theme }) => ({
  pageContainer: {
    maxWidth: '1000px',
    margin: 'auto',
    marginTop: theme.spacing(2)
  },
  contentWrapper: {
    backgroundColor: 'white',
    padding: '48px',
    display: 'flex',
    marginBottom: theme.spacing(4),
    [`${theme.breakpoints.down('md')}`]: {
      padding: '24px'
    },
    flexDirection: 'column',
    gap: '54px',
    img: {
      aspectRatio: 1 / 1,
      objectFit: 'cover'
    }
  }
}));
